/*
 * @Author: lbh
 * @Date: 2022-09-23 10:31:25
 * @LastEditors: lbh
 * @LastEditTime: 2022-10-26 12:10:36
 * @Description: 插件
 */
import selfCom from "./index.vue";

let currentCom;
export default {
  install(Vue, options) {
    // ? 建立或關閉唯一的支付輪詢實例。
    let f = (propsData, onBack = () => {}) => {
      // * 替換或關閉時銷毀舊實例，清理輪詢和返回事件。
      if (currentCom) {
        currentCom.$destroy();
        currentCom.$el.remove();
        currentCom = null;
      }
      console.log(typeof propsData);
      if (typeof propsData == "boolean") {
        if (!propsData && document.querySelector(".self-pay-loading"))
          document.querySelector(".self-pay-loading").remove();
        return;
      }
      document.body.classList.add("overflowHidden");
      currentCom = _create({
        Vue,
        propsData,
        onClose: () => {
          document.body.classList.remove("overflowHidden");
          currentCom = null;
        },
        onBack
      });
    };
    // 託管到 vue
    Vue.prototype.$payLoading = f;
    // 託管到 window
    window.$payLoading = f;
  }
};

function _create({ Vue, propsData, onClose, onBack }) {
  const Constructor = Vue.extend(selfCom);
  let twa = new Constructor({
    el: document.createElement("div"), // 設置掛載點, 不寫這個會報錯的哦
    propsData: propsData
  });
  twa.$on("close", onClose);
  twa.$on("back", onBack);
  // 加載到 body
  document.body.appendChild(twa.$el);
  return twa;
}
